import {
  UNWALKABLE,
  RED_PIECES,
  BLUE_PIECES,
  COLORLESS_PIECES,
  DOORS,
  BIG_DOORS,
  ITEMS,
  NON_EQUIPPABLE_ITEMS,
  LOCKED_DOOR,
  HIGHLIGHT_MOVE,
  HIGHLIGHT_KILL,
  HIGHLIGHT_MOVEKILL,
  ENEMY_MOVEKILL,
  ENEMY_MOVE,
  ENEMY_KILL,
  PATTERN_MOVE,
  PATTERN_ATTACK,
  PATTERN_MOVE_ATTACK,
  HIGHLIGHT_SELECTED,
  HIGHLIGHT_SELECTABLE,
  HIGHLIGHT_STAIRS_UP,
  HIGHLIGHT_STAIRS_DOWN,
  HIGHLIGHT_DOOR,
  HIGHLIGHT_NPC,
  pieceMovesets,
  TARGET_TILE,
  WALKABLE,
  LOGIC_DOOR,
  CHARACTERS
} from './constants';

import { itemMetaBySpriteIndex } from 'items/all_items_meta';

function canWriteToHighlightLayer(map) {
  if (!map || !map.layers || !map.putTileAt) {
    return false;
  }
  const highlightLayer = map.layers.find(
    layer => layer.name === 'highlight_layer'
  );
  return !!(highlightLayer && highlightLayer.tilemapLayer);
}

export function setTileSelected(tile, map) {
  if (!tile || !canWriteToHighlightLayer(map)) {
    return;
  }
  let newTile = map.putTileAt(
    HIGHLIGHT_SELECTED,
    tile.x,
    tile.y,
    false,
    'highlight_layer'
  );
  if (newTile) {
    newTile.currentHighlight = HIGHLIGHT_SELECTED;
    newTile.setAlpha(1);
  }
}
export function setTileSelectable(tile, map) {
  if (!tile || !canWriteToHighlightLayer(map)) {
    return;
  }
  let newTile = map.putTileAt(
    HIGHLIGHT_SELECTABLE,
    tile.x,
    tile.y,
    false,
    'highlight_layer'
  );
  if (newTile) {
    newTile.setAlpha(1);
  }
}
export function setTilesSelectable(pieces, map) {
  let tiles = pieces
    .getChildren()
    .filter(piece => piece.color === 'blue')
    .map(piece => piece.tile);
  tiles.forEach(tile => {
    setTileSelectable(tile, map);
  });
}

function createNewHighlightedTile(map, move, tile, enemySelected) {
  let moveIndex = move;
  if (tile.occupant) {
    moveIndex = enemySelected ? ENEMY_MOVEKILL : HIGHLIGHT_MOVEKILL;
  }

  const abovePlayerTile = map.getTileAt(tile.x, tile.y, true, 'above_player');
  const abovePlayerTileIndex = abovePlayerTile && abovePlayerTile.index;
  const belowPlayerTile = map.getTileAt(tile.x, tile.y, true, 'below_player');
  const belowPlayerTileIndex = belowPlayerTile && belowPlayerTile.index;
  const decorLayerTile = map.getTileAt(tile.x, tile.y, true, 'decor_layer');
  const decorLayerTileIndex = decorLayerTile && decorLayerTile.index;
  const logicTile = map.getTileAt(tile.x, tile.y, true, 'logic_layer');
  const logicTileIndex = logicTile && logicTile.index;
  const isLogicDoor = logicTileIndex === LOGIC_DOOR;

  if (logicTile && logicTile.npc) {
    moveIndex = HIGHLIGHT_NPC;
  }

  if (isLogicDoor) {
    if (
      [171, 207].includes(belowPlayerTileIndex) ||
      [171, 207].includes(decorLayerTileIndex)
    ) {
      moveIndex = HIGHLIGHT_STAIRS_UP;
    }
    if (
      [28, 136, 154, 172, 208].includes(belowPlayerTileIndex) ||
      [28, 136, 154, 172, 208].includes(decorLayerTileIndex)
    ) {
      moveIndex = HIGHLIGHT_STAIRS_DOWN;
    }
    if (
      BIG_DOORS.includes(belowPlayerTileIndex) ||
      BIG_DOORS.includes(decorLayerTileIndex) ||
      BIG_DOORS.includes(abovePlayerTileIndex)
    ) {
      moveIndex = HIGHLIGHT_DOOR;
    }
  }
  let newTile = map.putTileAt(
    moveIndex,
    tile.x,
    tile.y,
    false,
    'highlight_layer'
  );

  const tilesToCheckForFlip = [171, 154];
  if (
    tilesToCheckForFlip.includes(belowPlayerTileIndex) ||
    tilesToCheckForFlip.includes(decorLayerTileIndex)
  ) {
    newTile.setFlipX(true);
  } else {
    newTile.setFlipX(false);
  }

  return { moveIndex, newTile };
}

export function setTilesHighlighted(origin, tiles, map, enemySelected) {
  let move = enemySelected ? ENEMY_MOVE : HIGHLIGHT_MOVE;
  const tilesTouched = {};
  tiles
    .filter(tile => {
      if (!tilesTouched[tile.x]) {
        tilesTouched[tile.x] = {};
      }
      if (tilesTouched[tile.x][tile.y]) {
        return false;
      } else {
        tilesTouched[tile.x][tile.y] = 1;
      }
      return true;
    })
    .forEach((tile, index) => {
      const { newTile, moveIndex } = createNewHighlightedTile(
        map,
        move,
        tile,
        enemySelected
      );
      newTile.setAlpha(0);
      newTile.originalPixelY = newTile.pixelY;
      newTile.currentHighlight = moveIndex;
      newTile.pixelY -= 16;

      const distance = Math.floor(
        Math.sqrt(
          Math.pow(tile.x - origin.x, 2) + Math.pow(tile.y - origin.y, 2)
        )
      );
      const distMultiplier = Math.max(75 * (1 - 0.05 * index), 0);
      const targetY = newTile.pixelY + 16;
      map.scene.tweens.add({
        targets: newTile,
        props: {
          pixelY: { value: targetY },
          alpha: { value: 1 }
        },
        delay: distance * distMultiplier,
        duration: 120,
        ease: 'Quad.easeOut',
        onStop: () => {
          newTile.pixelY = newTile.originalPixelY;
        }
      });
      // newTile.setAlpha(1);
    });
}

export function setTilesHighlightedForProjectile(tiles, map) {
  let move = HIGHLIGHT_MOVE;
  tiles.forEach((tile, index) => {
    let moveIndex = move;
    if (tile.occupant) {
      moveIndex = HIGHLIGHT_MOVEKILL;
    }
    let newTile = map.putTileAt(
      moveIndex,
      tile.x,
      tile.y,
      false,
      'highlight_layer'
    );
    newTile.setAlpha(0.8);
  });
}

export function setTilesHighlightedForMultimove(tiles, map) {
  let move = HIGHLIGHT_MOVE;
  tiles.forEach((tile, index) => {
    let moveIndex = move;
    let newTile = null;
    if (!index) {
      moveIndex = HIGHLIGHT_SELECTED;
    } else if (tile.occupant) {
      moveIndex = HIGHLIGHT_MOVEKILL;
    } else if (index === tiles.length - 1) {
      moveIndex = TARGET_TILE;

      const { newTile: createdTile } = createNewHighlightedTile(
        map,
        move,
        tile,
        false
      );
      newTile = createdTile;
    }

    if (!newTile) {
      newTile = map.putTileAt(
        moveIndex,
        tile.x,
        tile.y,
        false,
        'highlight_layer'
      );
    }
    if (newTile.originalPixelY) {
      newTile.pixelY = newTile.originalPixelY;
    }
    newTile.setAlpha(0.8);
  });
}

export function setTilesTargeted(tiles, map, enemySelected) {
  tiles.forEach(tile => {
    let currentTile = map.getTileAt(tile.x, tile.y, true, 'highlight_layer');
    if (currentTile.index === -1) {
      let newTile = map.putTileAt(
        enemySelected ? ENEMY_KILL : HIGHLIGHT_KILL,
        tile.x,
        tile.y,
        false,
        'highlight_layer'
      );
      newTile.currentHighlight = HIGHLIGHT_KILL;
      newTile.setAlpha(1);
    }
  });
}

export function clearTileHighlighting(map, zone, layer = 'highlight_layer') {
  const rect = zone || {
    x: 0,
    y: 0,
    w: map.width,
    h: map.height
  };
  map.fill(-1, rect.x, rect.y, rect.w, rect.h, null, layer);
}

export function isValidPath(relativeTiles, origin, map, mapWidth) {
  let valid = true;
  relativeTiles.forEach(tile => {
    const { logicTile } = getTileLayers(tile, origin, map, mapWidth);
    if (logicTile) {
      // prevent passing through unwalkable tiles
      if (logicTile.index === UNWALKABLE) {
        valid = false;
      }
      // prevent passing through locked doors
      if (logicTile.index === LOCKED_DOOR) {
        valid = false;
      }
    }
  });
  return valid;
}

const recurseDirection = (
  coords,
  direction,
  moves,
  attacks,
  origin,
  map,
  color,
  hasKey,
  mapWidth
) => {
  const { logicTile } = getTileLayers(coords, origin, map, mapWidth);
  const nextTile = [coords[0] + direction[0], coords[1] + direction[1]];
  if (logicTile && logicTile.index !== UNWALKABLE) {
    let isPiece = RED_PIECES.concat(COLORLESS_PIECES, BLUE_PIECES).includes(
      logicTile.index
    );
    let isLockedDoor = logicTile.index === LOCKED_DOOR;
    let isDoorOrItem = DOORS.concat(ITEMS).includes(logicTile.index);
    let isWalkableNPC = logicTile.index === WALKABLE;
    if (isPiece) {
      let pieceColor = COLORLESS_PIECES.concat(RED_PIECES).includes(
        logicTile.index
      )
        ? 'red'
        : 'blue';
      if (pieceColor !== color) {
        moves.push(logicTile);
        attacks.push(logicTile);
      }
    } else if (isLockedDoor) {
      if (hasKey) {
        moves.push(logicTile);
        attacks.push(logicTile);
      }
    } else if (!isDoorOrItem || color === 'blue') {
      moves.push(logicTile);
      if (!isWalkableNPC) {
        recurseDirection(
          nextTile,
          direction,
          moves,
          attacks,
          origin,
          map,
          color,
          hasKey,
          mapWidth
        );
      }
    }
  }
};

export function getTileLayers(possibility, origin, map, mapWidth) {
  let logicTile;
  const x = origin.x + possibility[0];
  const y = origin.y + possibility[1];
  if (map.getTileAt) {
    logicTile = map.getTileAt(x, y, true, 'logic_layer');
  } else {
    if (
      x < mapWidth &&
      x > -1 &&
      y > -1 &&
      y < map.length / mapWidth &&
      map[x + y * mapWidth]
    ) {
      logicTile = { index: map[x + y * mapWidth], x, y };
    }
  }
  return {
    logicTile
  };
}

export function applyMoveToMapData(mapData, piece, target, mapRect) {
  let result = mapData.slice(0);
  let tile = piece.tile || piece;
  let offset = { x: 0, y: 0 };
  if (tile.x > mapRect.w || tile.y > mapRect.h) {
    offset.x = mapRect.x;
    offset.y = mapRect.y;
  }
  let pieceIndex = tile.x - offset.x + (tile.y - offset.y) * mapRect.w;
  let targetIndex = target.x - offset.x + (target.y - offset.y) * mapRect.w;

  result[pieceIndex] = -1;
  result[targetIndex] = tile.index;
  return result;
}

export function getPieceMoveSet(pieceTile, map, mapWidth, hasKey = null, ss) {
  if (!pieceTile) {
    return { moveSet: [], attackSet: [] };
  }
  let index = pieceTile.index;
  let pattern;
  let type;
  // console.log('get move attack set:', pieceTile.index);
  switch (index) {
    case 235:
    case 307:
    case 313:
    case 271:
    case 277:
    case CHARACTERS.fayette:
      pattern = pieceMovesets.Pawn;

      type = 'Pawn';
      break;
    case 308:
    case 314:
    case 272:
    case 278:
    case 284:
    case CHARACTERS.raide:
      pattern = pieceMovesets.Knight;

      type = 'Knight';
      break;
    case 319:
    case 320:
    case 321:
    case 322:
      pattern = pieceMovesets.Beast;
      type = 'Beast';
      break;
    case 309:
    case 315:
    case 273:
    case 279:
    case 285:
      pattern = pieceMovesets.Bishop;
      type = 'Bishop';
      break;
    case 310:
    case 316:
    case 274:
    case 280:
    case 286:
    case CHARACTERS.uncle:
      pattern = pieceMovesets.Rook;
      type = 'Rook';
      break;
    case 311:
    case 317:
    case 275:
    case 281:
    case 323:
    case CHARACTERS.angryQueen:
      pattern = pieceMovesets.Queen;
      type = 'Queen';
      break;
    case 312:
    case 318:
    case 276:
    case 282:
    case 288:
    case 324:
    case CHARACTERS.patzertonKing:
      pattern = pieceMovesets.King;
      type = 'King';
      break;
    default:
      break;
  }
  if (!pattern || !type) {
    return { moveSet: [], attackSet: [] };
  }
  return get5x5MoveSet(pieceTile, map, mapWidth, hasKey, pattern, type);
}

const recursePatterns = {
  a: [-1, -1],
  b: [0, -1],
  c: [1, -1],
  d: [-1, 0],
  e: [1, 0],
  f: [-1, 1],
  g: [0, 1],
  h: [1, 1]
};

const movesetCache = {};

function get5x5MoveSet(origin, map, mapWidth, hasKey, pattern, type) {
  const moveSet = [];
  const attackSet = [];
  let possibilities = [];
  let killZones = [];
  let recursiveDirections = [];
  let cachedMoveset = movesetCache[type];
  if (cachedMoveset) {
    possibilities = cachedMoveset.possibilities.slice(0);
    killZones = cachedMoveset.killZones.slice(0);
    recursiveDirections = cachedMoveset.recursiveDirections.slice(0);
  } else {
    pattern.forEach((row, x) => {
      row.forEach((type, y) => {
        const dest = [x - 2, y - 2];
        if (type === PATTERN_MOVE) {
          possibilities.push({ dest });
        }
        if (type === PATTERN_ATTACK) {
          killZones.push({ dest });
        }
        if (type === PATTERN_MOVE_ATTACK) {
          let poss = { dest };
          if (Math.abs(dest[0]) === 2 || Math.abs(dest[1]) === 2) {
            const paths = knightPaths[dest[0].toString()][dest[1].toString()];
            if (paths && paths.alpha) {
              poss.alpha = paths.alpha;
            }
            if (paths && paths.beta) {
              poss.beta = paths.beta;
            }
          }
          possibilities.push(poss);
          killZones.push(poss);
        }
        if (typeof type === 'string') {
          recursiveDirections.push(recursePatterns[type]);
        }
      });
    });

    movesetCache[type] = { possibilities, killZones, recursiveDirections };
  }
  const moverColor = BLUE_PIECES.includes(origin.index) ? 'blue' : 'red';
  possibilities.forEach(possibility => {
    const { logicTile } = getTileLayers(
      possibility.dest,
      origin,
      map,
      mapWidth
    );
    if (logicTile && logicTile.index !== UNWALKABLE) {
      if (
        !BLUE_PIECES.concat(RED_PIECES, COLORLESS_PIECES).includes(
          logicTile.index
        )
      ) {
        const isLockedDoor = logicTile.index === LOCKED_DOOR;
        if (!isLockedDoor || hasKey) {
          const isDoor = DOORS.includes(logicTile.index);
          const isItem = ITEMS.includes(logicTile.index);
          const isDoorOrItem = isDoor || isItem;
          const isNonEquippable = NON_EQUIPPABLE_ITEMS.includes(
            logicTile.index
          );
          if (isItem && !isNonEquippable) {
            const item = itemMetaBySpriteIndex[logicTile.index];
            const classMatchesRank = type.toLowerCase() === item.class;
            const classIsAny = item.class === 'any';
            const classIsFay = item.class === 'fayette';
            const pieceIsFay = [283, 284, 285].includes(origin.index);
            const classMatches =
              classMatchesRank || classIsAny || (pieceIsFay && classIsFay);
            const classMatchesItem = isItem && classMatches;
            if (!classMatchesItem) {
              return;
            }
          }
          if (!isDoorOrItem || (isDoorOrItem && moverColor === 'blue')) {
            if (possibility.alpha || possibility.beta) {
              const alphaValid =
                possibility.alpha &&
                isValidPath(possibility.alpha, origin, map, mapWidth);
              const betaValid =
                possibility.beta &&
                isValidPath(possibility.beta, origin, map, mapWidth);
              if (alphaValid || betaValid) {
                moveSet.push(logicTile);
              }
            } else {
              moveSet.push(logicTile);
            }
          }
        }
      }
    }
  });
  killZones.forEach(possibility => {
    const { logicTile } = getTileLayers(
      possibility.dest,
      origin,
      map,
      mapWidth
    );
    if (logicTile && logicTile.index > 0 && logicTile.index !== UNWALKABLE) {
      let bluePiece = BLUE_PIECES.includes(logicTile.index);
      let redPiece = RED_PIECES.includes(logicTile.index);
      let colorlessPiece = COLORLESS_PIECES.includes(logicTile.index);
      let isPiece = redPiece || bluePiece || colorlessPiece;
      let enemyColor = 'red';
      if (bluePiece) {
        enemyColor = 'blue';
      } else if (colorlessPiece) {
        enemyColor = 'colorless';
      }
      let isDoorOrItem = DOORS.concat(ITEMS).includes(logicTile.index);
      if (isPiece) {
        if ((enemyColor !== moverColor || !moverColor) && !isDoorOrItem) {
          if (possibility.alpha || possibility.beta) {
            const alphaValid =
              possibility.alpha &&
              isValidPath(possibility.alpha, origin, map, mapWidth);
            const betaValid =
              possibility.beta &&
              isValidPath(possibility.beta, origin, map, mapWidth);
            if (alphaValid || betaValid) {
              attackSet.push(logicTile);
            }
          } else {
            attackSet.push(logicTile);
          }
        }
      }
    }
  });
  recursiveDirections.forEach(possibility => {
    recurseDirection(
      possibility,
      possibility,
      moveSet,
      attackSet,
      origin,
      map,
      moverColor,
      hasKey,
      mapWidth
    );
  });
  return { moveSet, attackSet };
}

const knightPaths = {
  '-2': {
    '-2': {
      alpha: [[-1, -1]]
    },
    '-1': {
      alpha: [
        [-1, 0],
        [-2, 0]
      ],
      beta: [
        [0, -1],
        [-1, -1]
      ]
    },
    '0': { alpha: [[-1, 0]] },
    '1': {
      alpha: [
        [-1, 0],
        [-2, 0]
      ],
      beta: [
        [0, 1],
        [-1, 1]
      ]
    },
    '2': {
      alpha: [[-1, 1]]
    }
  },
  '-1': {
    '-2': {
      alpha: [
        [-1, 0],
        [-1, -1]
      ],
      beta: [
        [0, -1],
        [0, -2]
      ]
    },

    '2': {
      alpha: [
        [-1, 0],
        [-1, 1]
      ],
      beta: [
        [0, 1],
        [0, 2]
      ]
    }
  },
  '0': { '-2': { alpha: [[0, -1]] }, '2': { alpha: [[0, 1]] } },
  '1': {
    '-2': {
      alpha: [
        [1, 0],
        [1, -1]
      ],
      beta: [
        [0, -1],
        [0, -2]
      ]
    },
    '2': {
      alpha: [
        [1, 0],
        [1, 1]
      ],
      beta: [
        [0, 1],
        [0, 2]
      ]
    }
  },
  '2': {
    '-2': { alpha: [[1, -1]] },
    '-1': {
      alpha: [
        [1, 0],
        [2, 0]
      ],
      beta: [
        [0, -1],
        [1, -1]
      ]
    },
    '0': { alpha: [[1, 0]] },
    '1': {
      alpha: [
        [1, 0],
        [2, 0]
      ],
      beta: [
        [0, 1],
        [1, 1]
      ]
    },
    '2': { alpha: [[1, 1]] }
  }
};
